export const excisting_types = [
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Όψεως ή ταμιευτηρίου",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "Ταμιευτηρίου",
  "Κοινός λογαριασμός",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ",
  "-",
  "Δεν συμπληρώθηκε",
  "Κοινός",
  "Ταμιευτήριο",
  "Κοινός λογαριασμός με σύζυγο",
  "Προθεσμιακός λογαριασμός",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με σύζυγο)",
  "Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός με σύζυγο",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με σύζυγο",
  "Τρεχούμενος",
  "Δεν έχει συμπληρωθεί",
  "Όψεως",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ ($)",
  "Δεν συμπληρώθηκε από τον βουλευτή",
  "Όψεως ή Ταμιευτηρίου - Κοινός",
  "Κοινός Λογαριασμός Ταμιευτηρίου με σύζυγο",
  "ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΗ ΚΑΡΤΕΛΑ",
  "Δεν έχει συμπληρωθεί από το βουλευτή",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ /",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟ",
  "Λογαριασμός για επενδυτικά προϊόντα",
  "Δε συμπληρώθηκε από το βουλευτή",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου",
  "",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με τρίτο πρόσωπο)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ($)",
  "ΤΡΕΧΟΥΜΕΝΟΣ/ΟΨΕΩΣ/ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός",
  "Όψεως ή ταμιευτηρίου (κοινός με σύζυγο)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (USD)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (£)",
  "Τρεχούμενος λογαριασμός",
  "Όψεως ή ταμιευτηρίου + κοινός λογαριασμός",
  "Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός με σύζυγο και τέκνα",
  "ΕΝΕΧΥΡΙΑΣΜΕΝΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ USD",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με τέκνα)",
  "Μισθοδοσίας",
  "Κοινός προθεσμιακός λογαριασμός με σύζυγο",
  "Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός με τέκνα",
  "Προθεσμιακός - Κοινός",
  "Ταμιευτηρίου - Κοινός",
  "Κοινός λογαριασμός με συγγενή",
  "Tαμιευτηρίου",
  "Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός με συγγενή",
  "Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός με τέκνο",
  "Όψεως ή ταμιευτηρίου από κοινού με σύζυγο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ(GBP)",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με μητέρα",
  "Πολυμορφικός",
  "Όψεως ή Ταμιευτηρίου (κοινός με τέκνο)",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με σύζυγο και τρίτο πρόσωπο)",
  "Προθεσμιακή",
  "Επιχειρηματικός λογαριασμός",
  "Ταμιευτηρίου (κοινός με σύζυγο)",
  "Κοινός Λογαριασμός Ταμιευτηρίου με μητέρα",
  "Κοινός λογαριασμός ταμιευτηρίου",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με συγγενή)",
  "Προθεσμιακός - Κοινός λογαριασμός με σύζυγο",
  "Όψεως ή ταμιευτηρίου με σύζυγο",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με τέκνο",
  "Όψεως ή ταμιευτηρίου κοινός με σύζυγο",
  "Κοινός λογαριασμός όψεως με τρίτο πρόσωπο",
  "Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός με σύζυγο και τέκνο",
  "Συνδικαιούχος",
  "Καταθετικός",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ GBP",
  "Κοινός λογαριασμός Ταμιευτηρίου με αδελφό",
  "Κοινός λογαριασμός με σύζυγο όψεως ή ταμιευτηρίου",
  "Όψεως ή Ταμιευτηρίου- Κοινός",
  "Δεν έχει συμπληρωθεί από τον Βουλευτή",
  "Επιχειρηματικός",
  "Ταμιευτήριο (κοινός με σύζυγο)",
  "Πολυμορφικός λογαριασμός",
  "Κοινός λογαριασμός με αδελφό",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με τρίτο πρόσωπο",
  "Κοινός λογαριασμός με τέκνο",
  "Όψεως ή Ταμιευτηρίου - Kοινός",
  "Κοινός με μητέρα",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ(ΚΟΙΝΟΣ ΜΕ ΤΡΙΤΟΥΣ)",
  "Ταμιευτηρίου (Συνδικαιούχος)",
  "Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός με τρίτο πρόσωπο",
  "Όψεως και ταμιευτηρίου",
  "Προθεσμιακός (Κοινός λογαριασμός με σύζυγο)",
  "Κοινός με σύζυγο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΚΟΙΝΟΣ ΜΕ ΤΡΙΤΟΥΣ)",
  "Προθεσμιακός λογαριασμός (κοινός με σύζυγο)",
  "Κοινός λογαριασμός με σύζυγο - όψεως ή ταμιευτηρίου",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (GBP)",
  "Προθεσμιακός (κοινός με τέκνο)",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ($)",
  "Κοινός λογαριασμός με τρίτο πρόσωπο",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ ($)",
  "Κοινός - Όψεως",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΚΟΙΝΟΣ ΜΕ ΣΥΖΥΓΟ)",
  "Προθεσμιακός - Κοινός λογαριασμός",
  "Προθεσμιακός - Κοινός λογαριασμός με τέκνο",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με συγγενείς)",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με σύζυγο και τέκνα)",
  "Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός με συγγενείς",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΣΥΝΔΙΚΑΙΟΥΧΟΣ)",
  "Προθεσμιακός Λογαριασμός με σύζυγο",
  "Κοινός λογαριασμός με τη σύζυγο",
  "Ταμιευτηρίου κοινός με σύζυγο",
  "Κοινός λογαριασμός ταμιευτηρίου με τέκνο",
  "Κοινός λογαριασμός με τέκνα",
  "Όψεως ή ταμιευτηρίου (ανενεργός λογαριασμός)",
  "Κοινός λογαριασμός για επενδυτικά προϊόντα με σύζυγο",
  "Αποδοχών",
  "Current account",
  "Κοινός Λογαριασμός όψεως ή ταμιευτηρίου με κόρη",
  "ΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ ΜΕ ΣΥΖΥΓΟ ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Κοινός Λογαριασμός Ταμιευτηρίου με σύζυγο και κόρη",
  "Προθεσμιακός (κοινός λογαριασμός με σύζυγο και τρίτο πρόσωπο)",
  "ΤΡΕΧΟΥΜΕΝΟΣ/ ΟΨΕΩΣ/ ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "(κοινός με σύζυγο)",
  "Κοινός λογαριασμός Ταμιευτηρίου με σύζυγο και τέκνο",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με σύζυγο)",
  "Λοιποί",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με τέκνο)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ(ΚΟΙΝΟΣ ΜΕ ΣΥΖΥΓΟ)",
  "Κοινός προθεσμιακός λογαριασμός",
  "Κοινός λογαριασμός Ταμιευτηρίου με κόρη",
  "Λογαριασμός μισθοδοσίας",
  "Κοινός - Ταμιευτηρίου",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με το σύζυγο",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ (USD)",
  "Λογαριασμός εξόφλησης δανείου",
  "Κοινός λογαριασμός με σύζυγο Ταμιευτηρίου",
  "Κοινός λογαριασμός με μητέρα",
  "Όψεως ή ταμιευτηρίου κοινός με τέκνα",
  "Ασφαλιστήριο/Συνταξιοδοτικό",
  "Δεν συμπληρώθηκε από τη βουλευτή",
  "Κοινώς λογαριασμός",
  "Όψεως ή ταμιευτηρίου (αδρανής λογαριασμός)",
  "Κοινός λογ. Όψεως ή ταμιευτηρίου",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ(£)",
  "Εκλογικός λογαριασμός",
  "Κοινός λογαριασμός με σύζυγο και τέκνα",
  "Κοινός λογαρισμός με σύζυγο Ταμιευτηρίου",
  "Ταμιευτηρίου (κοινός με σύζυγο & τέκνο)",
  "Κοινός προθεσμιακός λογαριασμός με αδελφό",
  "Κοινός, επιχειρηματικός λογαριασμός με σύζυγο",
  "Δε συμπληρώθηκε από τον βουλευτή",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με βουλευτή",
  "Κοινώς λογαριασμός όψεως ή ταμιευτηρίου",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με τέκνα",
  "Κοινός λογαριασμός με το σύζυγο",
  "Προθεσμιακός (κοινός με σύζυγο)",
  "Τρεχούμενος (κοινός λογαριασμός με σύζυγο)",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με γονείς)",
  "Μισθοδοσία",
  "ΛΟΙΠΟΙ ΛΟΓΑΡΙΑΣΜΟΙ",
  "Όψεως ή ταμιευτηρίου (κοινώς με σύζυγο και τέκνο)",
  "Tαμιευτήριο",
  "Κοινοί λογαριασμοί με σύζυγο",
  "Κοινός λογαριασμός ταμιευτηρίου με τη σύζυγο",
  "Όψεως ή ταμιευτηρίου (κοινώς με σύζυγο)",
  "Ταμιευτηρίου - κοινός με μητέρα",
  "Ταμιευτηρίου - κοινός με λοιπούς συγγενείς",
  "Κοινός λογαριασμός όψεως με σύζυγο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΣΥΝΔΙΚΑΙΟΥΧΟΣ)",
  "Όψεως ή ταμιευτηρίου από κοινού με τέκνο",
  "ΤΡΕΧΟΥΜΕΝΟΣ/ ΤΑΜΙΕΥΤΗΡΙΟΥ/ ΟΨΕΩΣ",
  "ΕΘΝΙΚΗ ΤΡΑΠΕΖΑ",
  "Ταμιευηρίου",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩ",
  "Όψεως ή ταμιευτηρίου",
  "Θυρίδα",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ($)",
  "Προθεσμιακός (Συνδικαιούχος)",
  "Προθεσμιακός - Κοινός λογαριασμός με τέκνα",
  "Επενδυτικός λογαριασμός",
  "Όψεως ή ταμιευτηρίου - επιχειρηματικός λογαριασμός",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με αδελφό",
  "Κοινός λογαριασμός με σύζυγο, Ταμιευτηρίου",
  "Επενδυτικός λογαριασμός με σύζυγο και τέκνο",
  "Όψεως ή ταμιευτηρίου, επιχειρηματικός λογαριασμός",
  "Όψεως ή Ταμιευτηρίου (Συνδικαιούχος με λοιπούς συγγενείς)",
  "Ταμιευτηρίου κοινός με μητέρα και αδερφό",
  "Κοινός-προθεσμιακός λογαριασμός",
  "Προθεσμιακός + Κοινός λογαριασμός",
  "Κοινός λογαριασμός ταμιευτηρίου με πατέρα",
  "Κοινός λογαριασμός με σύζυγο, Όψεως ή Ταμιευτηρίου",
  "Κοινός λογαριασμός με μητέρα και αδερφό",
  "Κλειστός",
  "Όψεως 'Μεγαλώνω'",
  "Καταθετικός λογαριασμός",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Κοινός λογριασμός όψεως ή ταμιευτηρίου με τέκνα",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ( BRITISH POUND)",
  "Εκλογικός",
  "Κοινός λογαριασμός με σύζυγο,Όψεως ή Ταμιευτηρίου",
  "ΤΡΕΧΟΥΜΕΝΟΣ ΤΑΜΙΕΥΤΗΡΙΟΥ ΟΨΕΩΣ",
  "Όψεως ή ταμιευτηρίου (Λογαριασμός εξυπηρέτησης δανείου)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (Λίρες Αγγλίας)",
  "ΤΑΜΙΕΥΤΗΡΙΟΥ ($)",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με τη σύζυγο",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με σύζυγο και Αθαν.Ταλιαδούρο",
  "Οψεως ή ταμιευτηρίου",
  "Όψεως ή ταμιευτηρίου (Συνδικαιούχος με την σύζυγο)",
  "Κοινός προθεσμιακός λογαριασμός με σύζυγο και Αθαν.Ταλιαδούρο",
  "ΤΡΕΧΟΥΜΕΝΟΣ/ΟΨΕΩΣ/ΤΑΜΙΕΥΤΗΡΙΟΥ(GBP)",
  "Προθεσμιακή κατάθεση",
  "Μισθοδοτικός",
  "Προθεσμιακός (κοινός λογαριασμός με συγγενή)",
  "Όψεως ή ταμειυτηρίου",
  "Κοινός λογαριασμός ταμιευτηρίου με τέκνα",
  "Απλός",
  "Ταμιευτηρίου βασικό",
  "Κοινός λογαριασμός, όψεως ή ταμιευτηρίου με σύζυγο",
  "Κοινός λογαριασμός Ταμιευτηρίου με σύζυγο και τέκνα",
  "Κοινός - επιχειρηματικός λογαριασμός με σύζυγο",
  "Ταμιευτηρίου από κοινού με σύζυγο",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με γονείς",
  "Συνταξιοδοτικός μητέρας",
  "Κοινός λογαριασμός (κοινός με σύζυγο)",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ ($)",
  "Κοινός όψεως ή ταμιευτηρίου με σύζυγο",
  "Δεν συμπληρώθηκε από την βουλευτίνα",
  "συμπληρώθηκε",
  "Λογαριασμός για επενδυτικά προιόντα ( κοινός με σύζυγο)",
  "Κοινός λογαριασμός Όψεως ή ταμιευτηρίου με αδερφό",
  "Όψεως ή ταμιευτηρίου με σύζυγο και τέκνο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ ($ ΑΥΣΤΡΑΛΙΑΣ)",
  "Όψεως ή ταμιευτηρίου (Κοινός με θυγατέρα)",
  "Όψεως ή Ταμιευητηρίου",
  "Προθεσμιακός - Κοινός λογαριασμός με σύζυγο και τέκνα",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (RSD)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΚΟΙΝΟΣ)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ( $)",
  "Κοινός Λογαριασμός Επενδυτικός",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Κοινός Λογαριασμός όψεως ή ταμιευτηρίου με σύζυγο και κόρη",
  "Ταμιευτηρίου (κοινός λογαριασμός με τέκνο)",
  "ΚΟΙΝΟΣ ΕΠΙΧΕΙΡΗΜΑΤΙΚΟΣ ΛΟΓΑΡΙΑΣΜΟΣ ΜΕ ΤΕΚΝΟ",
  "ΤΑΜΙΕΥΤΗΡΙΟ ΚΟΙΝΟΣ ΜΕ ΣΥΖΥΓΟ",
  "Ταμιευτηρίου (συνδικαιούχος με σύζυγο)",
  "Saving Account (κοινός λογαριασμός με σύζυγο)",
  "Κοινός - Επιχειρηματικός",
  "ΟΨΕΩΣ Ή ΤΑΜΙΕΥΤΗΡΙΟΥ ΚΟΙΝΟΣ ΜΕ ΤΕΚΝΟ ΚΑΙ ΠΑΤΕΡΑ",
  "Κοινός Προθεσμιακός λογαριασμός με τέκνα",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με μητέρα και κόρη",
  "ΠΡΟΣΩΠΙΚΟΣ",
  "Προθεσμιακός (κοινός με σύζυγο και τέκνο)",
  "Σύνταξης",
  "Τρεχούμενος λογαριασμός - Compte Bancaire",
  "Κύριος Δικαιούχος",
  "Όψεως ή ταμιευτηρίου (κοινός με μητέρα)",
  "Κοινός λογαριασμός με σύζυγο Όψεως",
  "0",
  "Προθεσμιακός (κοινός με σύζυγο και τέκνα)",
  "Ταμιευτηρίου (κοινός λογαριασμός)",
  "Λογαριασμός Χορήγησης Πίστωσης, Credit Confience",
  "Κοινός λογαριασμός ταμιευτηρίου με γονείς και αδελφό",
  "Προθεσμιακός (κοινός λογαριασμός με τέκνο)",
  "Όψεως (κοινός με σύζυγο)",
  "Προθεσμιακός (κοινός με σύζυγο και τέκνο)",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ GBP",
  "Κοινός λογαριασμός Ταμιευτηρίου με Γονείς",
  "προθεσμιακός λογαριασμός κοινός με τέκνα",
  "Όψεως ή ταμιευτηρίου (κοινός με αδελφή)",
  "Όψεως ή ταμιευτηρίου (κοινώς με σύζυγο και τέκνα)",
  "Όψεως ή ταμιευτηρίου με τέκνο",
  "Ρευστό",
  "Κοινός προθεσμιακός λογαριασμός όψεως ή ταμιευτηρίου με τη μητέρα και την αδελφή του",
  "Κοινός λογαριασμός Όψεως ή Ταμιευτηρίου με τέκνα",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΒΡΕΤΑΝΙΚΗ ΛΙΡΑ)",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με αδελφό και μητέρα",
  "Alpha Bank",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΕΛΒΕΤΙΚΟ ΦΡΑΓΚΟ)",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με αδερφή",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (CHF)",
  "Θυρίδα (κοινή με σύζυγο)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ ( ΕΛΒΕΤΙΚΟ ΦΡΑΓΚΟ)",
  "Όψεως ή ταμιευτηρίου (κοινός με σύζυγο + τέκνο)",
  "Ταμιευτηρίου (Συνδιακαιούχος δεύτερο όνομα)",
  "Όψεως ή ταμιευτηρίου με συνδικαιούχο τον πατέρα",
  "Όψεως ή ταμιευτηρίου (Συνδικαιούχος με την κόρη)",
  "Όψεως ή ταμιευτηρίου, κοινός λογαριασμός με τέκνο",
  "Όψεως ή ταμιευτηρίου, κοινός λογαριασμός με σύζυγο",
  "Κοινός λογαριασμός ταμιευτηρίου με θυγατέρα",
  "Ταμιευτηρίου -κοινός με λοιπούς συγγενείς",
  "Προθεσμιακός κοινός λογαριασμός",
  "Κοινός λογαριασμός με σύζυγο και τέκνο)",
  "ΤΡΕΧΟΥΜΕΝΟΣ/ΟΨΕΩΣ/ΤΑΜΙΕΥΤΗΡΙΟΥ($)",
  "Ταμιευτηρίου από κοινού με μητέρα",
  "Όψεως ή Ταμιευτηρίου (κοινός με κόρη)",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με συγγενή και λοιπά πρόσωπα)",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με Μαρία Παπαπετροπούλου",
  "Φοιτητικός λογαριασμός",
  "Λογαριασμός καταθέσεων",
  "Visa Gold",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ(ΚΟΙΝΟΣ ΜΕ ΣΥΖΥΓΟ)",
  "ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΗ ΚΑΡΤΕΛΑ (USD)",
  "Κοινός λογαριασμός με γονέα",
  "Ταμιευτηρίου απλό",
  "Λογαριασμός για επενδυτικά προϊόντα - Κοινός",
  "Πολυμορφικός -Κ-",
  "Κοινός λογαριασμός Όψεως ή ταμιευτηρίου με σύζυγο",
  "Ταμιευτηρίου (κοινός με τέκνο)",
  "ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΗ ΚΑΡΤΕΛΑ ($)",
  "Κατεστραμμένο αρχείο pdf, δεν εμφανίστηκαν τα στοιχεία",
  "Επενδυτικός",
  "κοινός με σύζυγο και τέκνο",
  "Κοινός λογαρισμός ταμιευτηρίου με σύζυγο",
  "Κοινός λογαριασμός με γονείς",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ(CHF)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (₣)",
  "Ταμιευτηρίου - κοινός με τέκνο",
  "Κοινός - επιχειρηματικός λογαριασμός",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με υιό",
  "Ταμιευτήριο (κοινός με τέκνο)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΚΟΙΝΟΣ) (USD)",
  "Όψεως ή ταμιευτηρίου (κοινός με σύζυγο και τέκνα)",
  "Κοινός λογαρισμός όψεως ή ταμιευτηρίου με σύζυγο",
  "Κοινός λογαριασμός με πατέρα ταμιευτηρίου",
  "Προνομιακός",
  "Κοινός επιχειρηματικός λογαριασμός με αδερφό",
  "Κοινός προθεσμιακός λογαριασμός με πατέρα",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "Όψεως ή ταμιευτηρίου, επιχειρηματικός λογαριασμός (κοινός λογαριασμός με σύζυγο)",
  "Κοινός λογαριασμός με πατέρα",
  "Κοινός- Όψεως",
  "Αποταμίευση (κοινός με σύζυγο)",
  "Όψεως ή Ταμιευτηρίου(Συνδικαιούχος με λοιπούς συγγενείς)",
  "Current Account (κοινός λογαριασμός με σύζυγο)",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ ΤΡΕΧΟΥΜΕΝΟΣ Ή ΟΨΕΩΣ (ΣΥΝΔΙΚΑΙΟΥΧΟΣ ΜΕ ΤΗ ΘΕΙΑ ΚΑΙ ΤΟ ΤΕΚΝΟ)",
  "ΤΑΜΙΕΥΤΗΡΙΟ ΚΟΙΝΟΣ ΜΕ ΣΥΖΥΓΟ ΚΑΙ ΤΕΚΝΑ",
  "Ταμιευτηρίου (κοινός λογαριασμός με σύζυγο)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (USD)",
  "Προθεσμιακός λογαριασμός - Κοινός λογαριασμός με σύζυγο και τέκνο",
  "Όψεως ή ταμιευτηρίου - Livret Epargne Plus SG",
  "Όψεως ή ταμιευτηρίου κοινός με τον σύζυγο",
  "ΠΡΟΘΕΣΜΙΑΚΟ",
  "Ταμιευτήριο (Κοινός λογαριασμός με σύζυγο)",
  "Τρεχούμενος - Λογαριασμός εκλογών",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ( ΒΡΕΤΑΝΙΚΗ ΛΙΡΑ)",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ ΤΡΕΧΟΥΜΕΝΟΣ Ή ΟΨΕΩΣ (ΣΥΝΔΙΚΑΙΟΥΧΟΣ ΜΕ ΤΗ ΘΕΙΑ)",
  "Προθεσμιακή Κατάθεση (Συνδικαιούχος)",
  "ΟΨΕΩΣ ΕΠΙΧΕΙΡΗΜΑΤΙΚΟΣ",
  "Όψεως ή ταμιευτηρίου - A Livret A",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕ($)",
  "Αϋλος Τίτλος",
  "Ταμιευτήριο (Κοινός λογαριασμός με τέκνο)",
  "ΟΨΕΩΣ Ή ΤΑΜΙΕΥΤΗΡΙΟΥ ΚΟΙΝΟΣ ΜΕ ΜΗΤΕΡΑ",
  "Κοινός λογαριασμός με σύζυγοΤαμιευτηρίου",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ ΤΡΕΧΟΥΜΕΝΟΣ Ή ΟΨΕΩΣ",
  "PERSONAL AC.",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟ (USD)",
  "Τρεχούμενος (κοινός λογαριασμός με τέκνο)",
  "Κοινός προθεσμιακός λογαριασμός με μητέρα",
  "ΟΨΕΩΣ Ή ΤΑΜΙΕΥΤΗΡΙΟΥ ΚΟΙΝΟΣ ΜΕ ΤΕΚΝΟ",
  "Πολυμορφικός (κοινός με σύζυγο)",
  "Κοινός λογαριασμός με αδελφή",
  "Ταμιευτηρίου κοινός μητέρα και αδερφό",
  "Μισθοδοσίας Plus",
  "Συνάλλαγμα",
  "Όψεως ή ταμιετηρίου",
  "Όψεως ή ταμιευτηρίου+ προθεσμιακός λογαριασμός κοινός με τέκνα",
  "Ταμιευτήριο (κοινός με σύζυγο και τέκνα)",
  "Όψεως ή ταμιευτηρίου - Α Livret A",
  "Κοινός προθεσμιακός λογαριασμός ταμιευτηρίου με γονείς και αδελφό",
  "Ακίνητος",
  "Κοινός Πολυμορφικός Λογαριασμός με σύζυγο",
  "Ταμιευτήριο (συνδικαιούχα τα τέκνα)",
  "Ιδιωτικό Συνταξιοδοτικό",
  "Μισθοδοσία κοινός με σύζυγο",
  "Ταμιευτήριο Διαρκούς Ανάπτυξης - Livret Development Durable",
  "Cash Manager",
  "Ταμιευτήριο (συνδικαιούχος ο γιος)",
  "Ιδιωτικό Συνταξιοδοτικό Πρόγραμμα",
  "Όψεως ή ταμιευτηρίου (Savings)",
  "Μισθοδοσίας κοινός με σύζυγο",
  "Ταμιευτηρίου - Livret Epargne Plus SG",
  "Υπερταμιευτήριο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ(ΚΟΙΝΟΣ ΜΕ ΣΥΖΥΓΟ)($)",
  "Κοινός Λογαριασμός Ταμιευτηρίου με σύζυγο και μητέρα",
  "Μισθοδοσίας (συζύγου)",
  "Όψεως ή ταμιευτηρίου (Λογαριασμός εξυπηρέτησης καταναλωτικού δανείου)",
  "Κοινός προθεσμιακός λογαριασμός με αδελφό και μητέρα",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ ΜΕ ΣΥΖΥΓΟ ΚΑΙ ΤΡΙΤΟΥΣ ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Επενδυτικός λογ.",
  "Προθεσμιακός και Κοινός λογαριασμός",
  "Όψεως ή ταμιευτηρίου (Select)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΣΥΝΔΙΚΑΙΟΥΧΟΣ) (USD)",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με ανηψια",
  "Τρεχ.όψεως",
  "Ταμιευτηρίου- Κοινός",
  "Κοινός λογαριασμός με σύζυγο και τέκνα ταμιευτηρίου",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ(ΚΟΙΝΟΣ ΜΕ ΤΡΙΤΟΥΣ)",
  "Προθεσμιακός - Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός με τέκνα",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με συγγενή) - Λογαριασμός εξυπηρέτησης στεγαστικού δανείου",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ (ΤΡΊΤΟΙ) ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Προθεσμιακός-κοινός λογαριασμός",
  "Βουλευτική Αποζημίωση",
  "Εισερχόμενα εμβάσματα",
  "Αποταμίευσης από κοινού με μητέρα",
  "Overdraft",
  "ALPHA",
  "Δε συπληρώθηκε από το βουλευτή",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με ανιψιά",
  "ΑΝΑΛΗΨΕΩΣ",
  "Χρεωστική κάρτα",
  "Ταμιευτηρίου από κοινού με μητέρα και αδερφή",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με σύζυγο και τέκνα",
  "Όψεως ή ταμιευτηρίου και προθεσμιακός",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ(AUD)",
  "Προθεσμιακός - Όψεως ή ταμιευτηρίου",
  "Ταμιευτηρίου (Συνδιακαιούχος τρίτο όνομα)",
  "Όψεως ή ταμιευτηρίου - Μισθοδοσίας",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ (Ο ΛΟΓΑΡΙΑΣΜΟΣ ΑΦΟΡΑ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΟΥ, ΤΟΥ ΟΠΟΙΟΥ ΣΥΝΔΙΚΑΙΟΥΧΟΣ ΕΙΝΑΙ Ο ΣΥΖΥΓΟΣ ΚΑΙ ΔΕΝ ΑΣΚΕΙ ΚΑΜΙΑ ΔΙΑΧΕΙΡΙΣΗ)",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με την ανιψιά)",
  "ΤΑΜΙΕΥΤΗΡΙΟ-ΜΙΣΘΟΔΟΣΙΑΣ",
  "Τρεχούμενος κοινός με συζυγο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (AUD)",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με μητέρα και σύζυγο",
  "ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΗ ΚΑΡΤΕΛΑ($)",
  "Λογαριασμός εκλογικών εσόδων - δαπανών",
  "ΤΑΜΙΕΥΤΗΡΙΟΥ (£)",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ (Η ΚΑΤΑΘΕΣΗ ΑΦΟΡΑ ΣΕ ΛΟΓΑΡΙΑΣΜΟ ΤΡΙΤΩΝ, ΤΟΥ ΟΠΟΙΟΥ ΣΥΝΔΙΚΑΙΟΥΧΟΣ ΕΙΝΑΙ ΤΟ ΑΝΗΛΙΚΟ ΤΕΚΝΟ ΚΑΙ ΔΕΝ ΑΣΚΕΙ ΚΑΜΙΑ ΔΙΑΧΕΙΡΙΣΗ)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥΗΡΙΟΥ",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός με τη αδερφή)",
  "Όψεως ή ταμιευτηρίου από κοινού με αδελφούς",
  "Ταμιευτηρίου - Σύνταξ",
  "Προθεσμιακός (κοινός με σύζυγο + τέκνο)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ Ω",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ AUD",
  "Ταμιευτηρίου - κοινός με πατέρα",
  "Μισθοδοτικός (Βουλή)",
  "(κοινός με σύζυγο)",
  "Προθεσμιακός λογαριασμός - Κοινός λογαριασμός με συγγενείς",
  "Τρεχούμενος ατομικός",
  "ΤΡΕΧΟΥΜΕΝΟΣ /ΟΨΕΩΣ/ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Όψεως ή ταμιευτηρίου κοινός με υιό",
  "Τρεχούμενος - Πολυμορφικός - Κοινός λογαριασμός",
  "Κοινός με σύζυγο και μητέρα",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ BGN",
  "Όψεως ή ταμιευτηρίου (τρεχούμενος, πολυμορφικός)",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ( $)",
  "Όψεως ή ταμιευτηρίου συνδικαιούχος με γονείς",
  "Όψεως ή ταμιευηρίου",
  "ΤΡΕΧΟΥΜΕΝΟΣ (£)",
  "Κοινό λογαριασμός με σύζυγο",
  "#NAME?",
  "ΟΨΕΩΣ Η ΤΑΜΙΕΥΤΗΡΟΥ ΜΕ ΣΥΖΥΓΟ",
  "Όψεως ή ταμιευτηρίου κοινός με μητέρα και υιό",
  "Κοινός δανειακός λογαριασμός με θυγατέρα",
  "Τρεχούμενος Cash Manager",
  "Προθεσμιακός (Συνδικαιούχος με την κόρη)",
  "Ενέχυρο",
  "Όψεως ή ταμιευτηρίου (βουλευτικός)",
  "Κοινός λογαριασμός με σύζυγο και τέκνο",
  "Ταμιευτηρίου - κοινός με σύντροφο",
  "Δεν έχει συμπληρωθεί - Λογαριασμός της Χ. Ταγαράς & ΣΙΑ Ε.Ε.",
  "Κοινός λογαριασμός με κόρη",
  "Ταμιευτηρίου από κοινού με αδέλφια",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ ($) (ΚΟΙΝΟΣ ΜΕ ΤΡΙΤΟΥΣ)",
  "Όψεως ή Ταμιευτηρίου + Προθεσμιακός (κοινός με τέκνο)",
  "Λογαριαμός για επενδυτικά προϊόντα",
  "Προθεσμιακός με σύζυγο",
  "Βουλευτικός",
  "Όψεως ή ταμιευτηρίου, κοινός λογαριασμός με σύζυγο και τέκνο",
  "Όψεως ή ταμιευτηρίου κοινός μ σύζυγο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ(ΚΟΙΝΟΣ ΜΕ ΣΥΖΥΓΟ ΚΑΙ ΜΕ ΤΡΙΤΟΥΣ)",
  "Όψεως ή ταμιευτηρίου ( κοινός με σύζυγο",
  "Κοινός λογαριασμός με γονείς καιαδελφό",
  "Ταμιευτηρίου κοινός λογαριασμός",
  "Κοινός λογαριασμός με πατέρα και αδερδό",
  "Καταθετικός λογαριασμός (κοινός λογαριασμός με σύζυγο)",
  "Κοινός με σύζυγο και κόρη",
  "Κοινός λογαριασμός με γονείς και αδερφή",
  "Κοινός, προθεσμιακός λογαριασμός με σύζυγο",
  "Ταμ. Εγγύηση ενοικίου",
  "Προθεσμιακός Λογαριασμός ( κοινός με σύζυγο)",
  "Προθεσμιακός - κοινός με λοιπούς συγγενείς",
  "Μισθοδοτικός (κοινός λογαριασμός με σύζυγο και τέκνο)",
  "Προθεσμιακός λογαριασμόε",
  "Προθεσμιακός λογαριασμός (κοινός λογαριασμός με συγγενή)",
  "Όψεως ή Ταμιευτηρίου συνδικαιούχος με αδερφή και γονείς",
  "Προθεσμιακός κοινός με σύζυγο",
  "MASTERCARD",
  "Κοινός λογαριασμός με τέκνα όψεως ή ταμιευτηρίου",
  "Ταμιευτηρίου - κοινός λογαριασμός με σύντροφο",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με Αθαν.Ταλιαδούρο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (Συνδικαιούχος με σύζυγο)",
  "Κοινός λογαριασμός με τέκνο)",
  "Προθεσμιακός + Κοινός λογαριασμός με τέκνα",
  "ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ",
  "Προθεσμιακός (κοινός λογαριασμός με συγγενή)",
  "Όψεως ή ταμιευτηρίου - Κοινός λογαριασμός με τρίτα πρόσωπα",
  "Ταμιευτηρίου, συνδικαιούχος με αδερφή και γονείς",
  "Κοινός προθεσμιακός λογαριασμός με σύζυγος",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ ΛΟΓΑΡΙΑΣΜΟΣ ΑΠΟ ΚΟΙΝΟΥ ΜΕ ΣΥΖΥΓΟ",
  "Κοινός λογαριασμός με τέκνα και αύζυγο όψεως ή ταμιευτηρίου",
  "Εγγύηση Ενοικίου",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (Συνδικαιούχος με τρίτο, ΟΣΜΑΝ ΜΕΜΕΤ ΡΕΜΖΗ)",
  "Πειραιώς pre paid",
  "Όψεως ή ταμιευτηρίου + Κοινός λογαριασμός με τέκνα",
  "Κοινός λογαριασμός με τέκνα, όψεως ή Ταμιευτηρίου",
  "Εμπορικός",
  "Checking",
  "Λογαριασμός μισθοδοσίας, κοινός με σύζυγο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (Συνδικαιούχος με σύζυγο, και τρίτο)",
  "Προπληρωμένη Κάρτα",
  "Κοινός προθεσμιακός",
  "ΤΡΑΠΕΖΑ ΠΕΙΡΑΙΩΣ($)",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (Ο λογαριασμός ανοιξε υποχρεωτικά λόγω υποψηφιότητας του στις εκλογές)",
  "Όψεως ή ταμειυτηρίου κοινός με σύζυγο",
  "ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ(ΜΕ ΣΥΖΥΓΟ)($)",
  "Κοινός λογαριασμός προθεσμιακός με σύζυγο",
  "ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΗ ΚΑΡΤΕΛΑ (CAD)",
  "Κοινός λογαριασμός όψεως ή ταμιευτηρίου με τέκνο και σύζυγο",
  "Ταμιευτηρίου (κοινός με σύζυγο και τέκνο)",
  "Όψεως ή ταμιευτηρίου συνδικαιούχος με τέκνο",
  "ΤΡΕΧΟΥΜΕΝΟΣ (παλαιος λογαριασμός μισθοδοσίας)",
  "Τρεχούμενος - Κοινός λογαριασμός με τρίτο πρόσωπο",
  "Ταμειυτήριο",
  "Κοινός λογαριασμός ταμιευτηρίου με συγγενικό πρόσωπο",
  "Όψεως ή ταμιευτηρίου-κοινός λογαριασμός",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (GBP)",
  "Όψεως ή ταμιευτηρίου συνδικαιούχος με κόρη και μητέρα",
  "Κοινός λογαρισμός όψεως με Θυγατέρα",
  "Κοινός λογαριασμός με συγγενείς",
  "Ειδικός εκλογικός λογαριασμός",
  "ΤΡΕΧΟΥΜΕΝΟΣ (Παλαιός λογαριασμός μισθοδοσίας της κόρης του βουλευτή)",
  "Ασφαλιστικό πρόγραμμα",
  "Ασφαλιστικό προϊόν",
  "Τρεχούμενος (ποσοστό συμμετοχής 33,39%)",
  "ΕΠΕΝΔΥΤΙΚΟΣ ΛΟΓΑΡΙΑΣΜΟΣ ($)",
  "Μετρητά",
  "κοινός με τέκνο",
  "Κοινός λογαρισμός όψεως ή Ταμιευτηρίου με Θυγατέρα",
  "Εξασφαλιστικός δανείου",
  "Τραπεζική θυρίδα (κοινή με σύζυγο)",
  "ΤΡΕΧΟΥΜΕΝΟΣ (Παλαιός λογαριασμός μισθοδοσίας της θείας του βουλευτή)",
  "Prepaid",
  "Προθεσμιακός - Επενδυτικός",
  "Λογαριασμός για επενδυτικά προϊόντα από κοινού με σύζυγο",
  "Λογαριασμός αποδοχών",
  "Εμπορικός λογαριασμός",
  "Επενδυτικά προϊόντα",
  "ΤΡΕΧΟΥΜΕΝΟΣ ($) / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Ταμιευτηρίου απλό κοινός με σύζυγο",
  "Τρεχούμενος - Κοινός λογαριασμός με σύζυγο",
  "Προθεσμιακός λογαριασμός κοινός με την σύζυγο",
  "Δυτικο",
  "Κοινός λογαριασμός με σύζυγο και θυγατέρα",
  "Κοινός λογαριασμός, όψεως ή ταμιευτηρίου με βουλευτή",
  "Κοινός Λογαριασμός Όψεως ή Ταμιευτηρίου με θυγατέρα",
  "Ταμιευτηρίου (ποσοστό συμμετοχής 33,39%)",
  "Ταμιευτηρίου - Μισθοδοασίας",
  "Κοινός προθεσμιακός λογαριασμός με γονείς",
  "Πριθεσμιακός",
  "ΩΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Τρεχούμενος (αποδοχών) κοινός με σύζυγο",
  "Κοινός λογαριασμός με τέκνο, Ταμιευτηρίου",
  "Κοινός λογαριαμός με βουλευτή",
  "Όψεως ή ταμιευτηρίου (κοινός λογαριασμός)",
  "Κοινός λογαριασμός, όψεως ή ταμιευτηρίου",
  "Κοινός λογαριασμός ταμιευτηρίου με τρίτο πρόσωπο",
  "Όψεως ή ταμιευτηρίου - επιχειρηματικός λογαριασμός (κοινός λογαριασμός με σύζυγο)",
  "Μισθοδοσία Βουλής",
  "Ταμιευτηρίου (Συνδικαιούχος με μητέρα)",
  "Τμιευτηρίου",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ GDP",
  "Τρεχούμενος πολυμορφικός λογαριασμός",
  "Προθεσμιακός λογαριασμός + Κοινός λογαριασμός",
  "Κοινός προθεσμιακός λογαριασμός με αδερφό",
  "Τρεχούμενος λογαριασμός (μισθοδοσίας)",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ (ΔΟΛΑΡΙΟ ΑΥΣΤΡΑΛΙΑΣ)",
  "Όψεως ή ταμιευτηρίου (Κοινός με σύζυγο και θυγατέρα)",
  "Ταμιευτηρίου (Συνδικαιούχος με κόρη - Σπουδαστικός λογαριασμός)",
  "ΤΡΕΧΟΥΜΕΝΟΣ/ ΟΨΕΩΣ /ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Μισθοδοτικός λογαριασμός",
  "Τρεχούμενος λογαριασμός (κοινός λογαριασμός με τέκνα)",
  "Κοινός λογαριασμός με σύζυγο, Τρεχούμενος",
  "Προθεσμιακός Λογαρισμός (κοινός με σύζυγο)",
  "Ταμιευτηρίου - κοινός με πρώην σύζυγο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ(USD)",
  "Προθεσμιακός λογαριασμός (κοινός λογαριασμός με τέκνα)",
  "Κοινός προθεσμιακός λογαριασμός με τέκνο",
  "Δανειακός",
  "Προθεσμιακός λογαριασμός με σύζυγο και τέκνκο",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ ($ ΚΑΝΑΔΑ)",
  "Όψεως ή ταμιευτηρίου ( Κοινός με θυγατέρα)",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ(USD)",
  "Μακροχρόνια επένδυση",
  "τΤαμιευτηρίου",
  "ΟΨΕΩΣ Ή ΤΑΜΙΕΥΤΗΡΙΟΥ ΚΟΙΝΟΣ ΜΕ ΣΥΖΥΓΟ ΚΑΙ ΤΕΚΝΟ",
  "Όψεως ή ταμιευτηρίου (κοινός με σύζυγο και τέκνο)",
  "Μισθοδοσίας/Σύνταξης",
  "ΤΡΕΧΟΥΜΕΝΟΣ/ΟΨΕΩΣ/ΛΟΓΑΡΙΑΣΜΟΥ",
  "Προθεσμιακός - - Κοινός λογαριασμός με σύζυγο",
  "ΚΟΙΝΟΣ ΛΟΓΙΑΡΙΑΣΜΟΣ ΜΕ ΣΥΖΥΓΟ ΚΑΙ ΤΕΚΝΟ ΟΨΕΩΣ Ή ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Όψεως ή ταμιευτηρίου + Επιχειρηματικός λογαριασμός",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΔΙΚΑΙΟΥΧΟΣ ΤΟΥ ΛΟΓΑΡΙΑΣΜΟΥ ΕΙΝΑΙ Η ΜΗΤΕΡΑ ΤΗΣ ΣΥΖΥΓΟΥ, ΕΙΡΗΝΗ ΤΟΛΗ- 5. ΤΑ ΧΡΗΜΑΤΑ ΠΡΟΕΡΧΟΝΤΑΙ ΑΠΟ ΑΠΟΖΗΜΙΩΣΗ ΛΟΓΩ ΑΠΟΛΥΣΗΣ ΑΠΟ ΤΗΝ ΕΡΓΑΣΙΑ ΤΗΣ)",
  "Διαθέσιμα",
  "Λογαρισμός για επενδυτικά προϊόντα",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ/ ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ(JPY)",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ ΜΕ ΤΕΚΝΟ ΟΨΕΩΣ Ή ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Επιχειρηματικός λογαρασμός",
  "Κοινός τρεχούμενος λογαριασμός με σύζυγο με σύζυγο",
  "Επιχειρηματικός- Όψεως",
  "Χρηματικό υπόλοιπο Cash",
  "ΕΤΕΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "Όψεως - Μισθοδοσίας",
  "Αποταμίευση",
  "Προθεσμιακή (κοινός λογαριασμός με τέκνο)",
  "Προθεσμιακός λογαριασμός με τέκνο",
  "Ειδικός τραπεζικός λογαριασμός διακίνησης εκλογικών εσόδων και δαπανών",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ (ΤΑ ΛΕΦΤΑ ΕΙΝΑΙ ΤΟΥ ΠΡΩΤΟΥ ΣΥΝΔΙΚΑΙΟΥΧΟΥ)",
  "Όψεως ή ταμιευτηρίου (κοινώς με τέκνο)",
]

export const new_types = [
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΧΡΗΜΑΤΙΣΤΗΡΙΑΚΗ ΚΑΡΤΕΛΑ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΛΟΓΑΡΙΑΣΜΟΣ ΓΙΑ ΕΠΕΝΔΥΤΙΚΑ ΠΡΟΪΟΝΤΑ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΜΙΣΘΟΔΟΣΙΑΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΚΟΙΝΟΣ ΛΟΓΑΡΙΑΣΜΟΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΠΡΟΘΕΣΜΙΑΚΟΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
  "ΤΡΕΧΟΥΜΕΝΟΣ / ΟΨΕΩΣ / ΤΑΜΙΕΥΤΗΡΙΟΥ",
]